<template>
    <v-container fluid class="pa-0">
        <v-row class="col-xs-12 col-sm-8 col-md-7 col-lg-5 col-xl-4 ml-auto mr-auto">
            <v-col class="d-flex flex-wrap justify-center pa-0">
                <v-form ref="form" v-on:submit.stop.prevent="" class="text-center col-12">
                    <v-col class="title primary--text">
                        <h2>Sign In</h2>
                    </v-col>
                    <v-col>
                    If you have an account with us, please sign in.
                    </v-col>
                     <!-- Company email -->
                    <v-text-field
                        ref="userId"
                        v-model="userId"
                        label="Company email"
                        :rules="[
                            () => !!userId || 'This Email is required',
                        ]"
                        dense
                        outlined
                        required
                        autocapitalize="none"
                    ></v-text-field>
                    <!-- Company password -->
                    <v-text-field
                        ref="pwd"
                        v-model="pwd"
                        label="Enter your password"
                        :append-icon="showPwd ? 'fas fa-eye' : 'fas fa-eye-slash'"
                        :type="showPwd ? 'text' : 'password'"
                        :rules="[
                            function(){ return !!pwd || 'This password is required'; },
                        ]"
                        @click:append="showPwd = !showPwd"
                        dense
                        outlined
                        required
                    ></v-text-field>
                    <!-- Remember me check -->
                    <div>
                        <v-checkbox class="my-0" label="Remember me" v-model="checkRememberMe"></v-checkbox>
                    </div>
                    <div v-show="!otpInputShow">
                        <div class="mx-auto cf-turnstile" id="recaptcha-container"></div>
                    </div>
                    <div v-show="otpInputShow">
                        <!-- OTP 전송 대상 화면과, 전송 버튼이 보여야 한다 -->
                        <div>
                            <v-select
                                :items="otpSelectSources"
                                item-text="source"
                                item-value="sourceHash"
                                v-model="otpSelectValue"
                                v-bind:data-placeholder="'OTP Choose one of registered.'"
                                solo
                            >
                            </v-select>
                            <!-- OTP 기다리는 시간 동안 SEND 할 수 없다 -->
                            <v-btn v-show="isAvailableSendOtpFirst"
                                    type="button"
                                    class="btn btn-primary waves-effect waves-light w-100 mb-4"
                                    @click="otpSendWithSource">
                                Send OTP
                            </v-btn>
                        </div>
                        <!-- OTP 전송이 되면 시간이 흐른다 -->
                        <div v-show="otpTimerSecondsRest>0" class="mb-4">
                            <div style="position:relative;">
                                <v-text-field
                                    class="relative"
                                    v-model="otpInputValue"
                                    label="Enter OTP"
                                    dense
                                    outlined
                                    required
                                    autocapitalize="none"
                                ></v-text-field>
                                <div class="text-right p-2"
                                     style="position:absolute; right: 8px; top: 8px; color: gray;"
                                     v-text="otpTimerShow"></div>
                            </div>
                            <!-- OTP 기다리는 시간 동안 SEND 할 수 없다 -->
                            <v-btn v-show="isAvailableResendOtp"
                                   type="button"
                                   class="btn btn-primary waves-effect waves-light w-100 mb-4"
                                   @click="otpSendWithSource">
                                ReSend OTP
                            </v-btn>
                        </div>
                    </div>
                    <v-btn color="primary"
                           block
                           v-show=" (otpTimerSecondsRest>0) || (!otpInputShow) "
                           @click="onSubmitWithOtp">
                        Sign in
                    </v-btn>
                    <v-col>
                        <v-btn color="error" @click="onClickForgotPassword" text>Forgot Password?</v-btn>
                    </v-col>
                    OR
                    <a href="https://new.biztreats.ph">
                        <v-btn color="blue" dark block >New Biz Treats</v-btn>
                    </a>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import ajaxTool from '@/plugins/ajax-tool';
import {DateUtil, RouteUtil, PageCache, MessageUtil} from '@/plugins/app-util';
// Mandatory API Server
import { apiServer } from '@/plugins/sti-api-server';

export default {
    name: "signInForm",
    components: {
    },
    data() {
        const rememberMeOn = this.$cookie.get('rememberMeCheck') || false;
        const rememberMeUserId = this.$cookie.get('rememberMeUserId') || '';
        return {
            userId: rememberMeOn ? rememberMeUserId:'',
            pwd: '',
            showPwd: false,
            cfTurnstileToken : '',
            cfTurnstileWidgetId : '',
            checkRememberMe : rememberMeOn,

            otpInputShow: false,
            otpInputValue: '',
            otpTimerShow : '',
            otpTimerSecondsRest : 0, // 0 초 남았다. (안보여준다)
            otpTimerWaitDefaultSec : 5*60, // 최대 OTP 기다리는 시간
            otpTimerResendAvailableSec : (5*60)-(5*60), // OTP Resend 가 가능한 시간, 5*60초가 지나면 Resend 가 가능하다., 현재는 다른 서비스와 동일하게 기다려야 한다.
            otpTimerInterval: null,

            otpSelectValue: '',  // 선택한 전화번호나 메일을 선택한다.
            otpSelectSources: [], // 선택할 수 있는 전화번호와 이메일 목록
            otpSendToken: '',    // 선택한 전화번호나 메일을 전송할 수 있는 임시 토큰
        };
    },
    mounted : function(){
        const vue = this;

        vue.loadCloudFlareApi();
        // 일단 otpTimer 는 항상 돌고 있도록 하자. 0
        if( ! vue.otpTimerInterval ){
            vue.otpTimerInterval = setInterval(function() {
                if( vue.otpTimerSecondsRest <= 0 ){
                    vue.otpTimerShow = '';
                    return;
                }
                vue.otpTimerSecondsRest -= 1;
                // 초를 분 00:00 초로 변환해서 보여준다.
                let min = vue.otpTimerSecondsRest/60;
                let sec = vue.otpTimerSecondsRest%60;

                if( min < 10 ) min = ('0'+Math.floor(min));
                if( sec < 10 ) sec = ('0'+Math.floor(sec));

                vue.otpTimerShow = (min +':'+sec);
            }, 1000);
        }
    },
    methods: {
        loadCloudFlareApi(){
            const self = this;

            const isDev = process.env.VUE_APP_SERVER_MODE === 'dev'; // local

            window.onloadTurnstileCallback = function () {
                self.cfTurnstileWidgetId = turnstile.render('#recaptcha-container', {
                    sitekey: (isDev ? '0x4AAAAAAAcsFEoHpLa4iCOH' : '0x4AAAAAAAcsEGREjkd4VveK'),
                    theme: 'light',
                    callback: function(token) {
                        self.cfTurnstileToken = token;
                    },
                });
            };

            const ele = document.createElement("script");
            ele.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback&render=explicit';
            document.getElementsByTagName("head")[0].appendChild(ele);
        },
        checkReCaptcha : function(){
            if( this.cfTurnstileToken ) return this.cfTurnstileToken;

            // recaptcha check alert
            this.$dialog({
                title : 'Check recaptcha',
                text  : 'Please check Captcha first.',
                type  : 'WARNING',
                button1Text : 'OK',
            });

            return;
        },
        onSubmitWithOtp : function(){
            var vue = this;

            // Check validation
            if (!this.$refs.form.validate()) {
                return;
            }

            // OTP 를 확인하는 때는 Recaptcha 를 사용하는 때 이다.
            const otpVerifyPhase = vue.otpInputShow;

            const p_userId = this.userId.trim().toLowerCase();
            const p_pwd  = this.pwd;

            // Saving Cookie or Delete
            if( vue.checkRememberMe ){
                vue.$cookie.set('rememberMeCheck', true, {path: window.location.pathname});
                vue.$cookie.set('rememberMeUserId', p_userId, {path: window.location.pathname});
            }else{ // remove Cookie
                vue.$cookie.delete('rememberMeCheck', {path: window.location.pathname});
                vue.$cookie.delete('rememberMeUserId', {path: window.location.pathname});
            }

            var sendData = {
                userId : p_userId,
                pwd : p_pwd,
            };
            if( otpVerifyPhase ){
                sendData.otp = vue.otpInputValue.trim();
                sendData.otpToken = vue.otpSendToken;

                if( ! sendData.otp || ! sendData.otpToken ){
                    vue.$dialog({
                        title : 'Notice',
                        text  : 'Please check your OTP first.',
                        type  : 'INFO',
                        button1Text : 'OK',
                        button1Action : function(){
                        },
                    });
                    return;
                }

            }else{
                var p_recaptcha = this.checkReCaptcha();
                if( ! p_recaptcha ) return;

                sendData.reCaptcha = p_recaptcha;
            }

            var uri = apiServer.uri("post-login").asString();

            ajaxTool.request({
                method: 'post',
                url: uri,
                requestTypeJson: true,
                data : sendData,

            }).then(function (data) {
                var fail_dialog_title = 'Sign in fail';

                // STRB-1374
                // Issue Legacy old password by attacker, we block, so cancel user log-on move to forgot password page
                var result_code = data.result_code;
                if( result_code === 104 ){
                    vue.$dialog({
                        title : 'Notice',
                        text  : 'Your password has expired, Please reset your password.',
                        type  : 'WARNING',
                        button1Text : 'OK',
                        button1Action : function(){
                            var redirect_uri = (data.data && data.data.redirect_uri) || '/index.html';
                            location.href = redirect_uri;
                        },
                    });
                    return;
                }

                // BIZTREATS_SIGNIN_100_OTP_SELECT, OTP 인증이 필요하다.
                if( data.result_code === 100 ) {
                    const otp_sources = data.otp_sources;
                    const otp_token = data.otp_token;

                    vue.otpSelectSources = otp_sources; // OTP 보낼 목록 선택창.
                    vue.otpSendToken = otp_token; // 전화번호 선택 후 OTP 전송 허용
                    vue.otpInputShow = true;      // OTP 전송 창 보이기

                    // OTP 보낼 목록 중 1번째 (이메일이 최우선) 이 있다면 자동 선택을 시킨다.
                    if( vue.otpSelectSources && vue.otpSelectSources.length>0 ){
                        vue.otpSelectValue = vue.otpSelectSources[0].sourceHash;
                    }

                    return;
                }

                // BIZTREATS_SIGNIN_101_OTP_NOT_MATCHED, OTP 가 틀렸다.
                if( data.result_code === 101 ) {

                    vue.$dialog({
                        title : 'Notice',
                        text  : 'You have entered an invalid One-Time PIN (OTP). Please double-check and try again.',
                        type  : 'INFO',
                        button1Text : 'OK',
                        button1Action : function(){
                        },
                    });
                    return;
                }

                // BIZTREATS_SIGNIN_OTP_TOKEN_INVALID, OTP Token (요청/확인 할 수 있는 권한)이 만료되었다
                if( data.result_code === 102 ) {

                    vue.$dialog({
                        title : 'Notice',
                        text  : 'OTP session expired, please retry again.',
                        type  : 'INFO',
                        button1Text : 'OK',
                        button1Action : function(){
                            location.reload();
                        },
                    });
                    return;
                }

              if (data.result_code === 202) {
                vue.$dialog({
                  title : 'Notice',
                  text  : 'Non-access user type. Please contact your Biz Treats account manager.',
                  type  : 'INFO',
                  button1Text : 'OK',
                  button1Action : function(){
                    location.reload();
                  },
                });
                return;
              }

                var handled = MessageUtil.showFailMessage(vue, data, fail_dialog_title, 'WARNING');
                if( handled ) return;

                var redirect_uri = (data.data && data.data.redirect_uri) || '/myprofile/myprofile.html';
                var button1Action = () => {
                    // Saving cookie to retrieve product
                    vue.$cookie.set('retrieveProductKey', (new Date()).getTime(), {expires: 1, path: '/'});

                    location.href = redirect_uri;
                }
                button1Action();

            }).catch(function (err) {
                var err_dialog_title = 'Sign in error';
                MessageUtil.showFailMessage(vue, err, err_dialog_title, 'ERROR');

            }).finally(function () {
                turnstile.reset(self.cfTurnstileWidgetId);
            });
        },
        otpSendWithSource : function(){
            var vue = this;

            // Check validation
            if (!this.$refs.form.validate()) {
                return;
            }

            const p_userId = this.userId.trim().toLowerCase();
            const p_otpSourceHash  = this.otpSelectValue;
            const p_otpToken  = this.otpSendToken;

            if( ! p_otpSourceHash || ! p_otpToken ){

                vue.$dialog({
                    title : 'Notice',
                    text  : 'Please choose one of registered in the account.',
                    type  : 'INFO',
                    button1Text : 'OK',
                    button1Action : function(){
                    },
                });
                return;
            }

            var uri = apiServer.uri("post-login-otp-send").asString();
            var sendData = {
                userId : p_userId.toLowerCase().trim(),
                otp_token : p_otpToken,
                source_hash : p_otpSourceHash,
            };

            ajaxTool.request({
                method: 'post',
                url: uri,
                requestTypeJson: false,
                data: sendData

            }).then(function (data) {

                var result_code = data.result_code;

                // OTP 성공했다.
                if( result_code === 200 ) {
                    vue.otpTimerSecondsRest = vue.otpTimerWaitDefaultSec; // OTP 를 보냈다. 서버에 5분 하드코딩.
                    return;
                }

                // BIZTREATS_SIGNIN_OTP_TOKEN_INVALID, OTP Token (요청/확인 할 수 있는 권한)이 만료되었다
                if( data.result_code === 102 ) {

                    vue.$dialog({
                        title : 'Notice',
                        text  : 'OTP session expired, please retry again.',
                        type  : 'INFO',
                        button1Text : 'OK',
                        button1Action : function(){
                            location.reload();
                        },
                    });
                    return;
                }

                vue.$dialog({
                    title : 'Error',
                    text  : 'Something went wrong, we are working on getting this fixed as soon as we can.',
                    type  : 'WARNING',
                    button1Text : 'OK',
                    button1Action : function(){
                    },
                });
                return;

            }).catch(function (err) {
                var err_dialog_title = 'OTP error';
                MessageUtil.showFailMessage(vue, err, err_dialog_title, 'ERROR');
            }).finally(function () {
                turnstile.reset(self.cfTurnstileWidgetId);
                vue.otpInputValue = '';
            });
        },
        onClickForgotPassword : function() {
            new RouteUtil("/forgot/forgot.html").go();
        },
        onClickSignUp : function() {
            new RouteUtil("/sign/signUp.html").go();
        },
    },
    computed : {
        isAvailableSendOtpFirst(){
            return this.otpTimerSecondsRest <= 0;
        },
        isAvailableResendOtp() {
            if( this.otpTimerSecondsRest <= 0 ){ // Resend 는 가리고, FirstSend 가 켜지게 한다.
                return false;
            }
            // Resend 할 수 있는 시간이 도달해서, 버튼을 보일 수 있다.
            return this.otpTimerSecondsRest < this.otpTimerResendAvailableSec;
        }
    }
};
</script>

<style scoped>

</style>
